/**
 * Caste Filter Configuration
 *
 * This file contains the list of allowed castes for this project.
 * Only these 6 specific castes will be shown in the application.
 */

// Allowed Caste IDs - Only these 6 castes will be visible
export const ALLOWED_CASTE_IDS = [
  '56a0f870-2502-41d5-bb6e-57ecfa0fa9a4', // गवळी
  '8d2b0f6a-3c1e-4b94-9e3a-0c2d7b614a70', // मुस्लीम गवळी
  'b1d62f9c-0a7e-4b18-9e3a-0c2d7b614a84', // गवलान
  '3e6f1d7c-9b50-4a10-8d2b-1a0c7e2d9f63', // ग्वालवंश
  '6a0f2d7c-9b31-4e84-a1d6-0c2e7b3d9f15', // गोपाल-गवळी
  '1d2e7c9b-0a61-4f39-8b7d-3c9e2f1a6d70'  // गवळी-गोपाल
];

// Allowed Caste Names (for reference and fallback filtering)
export const ALLOWED_CASTE_NAMES = [
  'गवळी',
  'मुस्लीम गवळी',
  'गवलान',
  'ग्वालवंश',
  'गोपाल-गवळी',
  'गवळी-गोपाल'
];

/**
 * Filter castes to show only the allowed ones
 * @param {Array} castes - Array of caste objects from API
 * @returns {Array} Filtered array containing only allowed castes
 */
export function filterAllowedCastes(castes) {
  if (!Array.isArray(castes)) {
    return [];
  }

  return castes.filter(caste => {
    // Filter by ID (primary method)
    if (caste.CasteID && ALLOWED_CASTE_IDS.includes(caste.CasteID)) {
      return true;
    }

    // Fallback: Filter by name if ID match fails
    const casteName = (caste.CasteName || '').trim();
    return ALLOWED_CASTE_NAMES.some(allowedName =>
      casteName.includes(allowedName)
    );
  });
}

export default {
  ALLOWED_CASTE_IDS,
  ALLOWED_CASTE_NAMES,
  filterAllowedCastes
};



// WEBPACK FOOTER //
// ./src/services/casteFilter.js